module.exports = __webpack_public_path__ + "7fad4c9e181fa6aa7406aa395a1353dc.png";